import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    createFoodBom:  () => {
        return HTTP.get('/lot/create_foodbom', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}